import auditLogs from 'src/features/audit-logs/locales/pl';
import authFeature from 'src/features/auth/locales/pl';
import createSite from 'src/features/create-site/locales/pl';
import events from 'src/features/events/locales/pl';
import issuesManagement from 'src/features/issues-management/issue-manager/locales/pl';
import issues from 'src/features/issues-management/shared/locales/pl';
import issueManagers from 'src/features/issues-management/site/issue-managers/locales/pl';
import siteIssues from 'src/features/issues-management/site/issues/locales/pl';
import messages from 'src/features/messages/locales/pl';
import password from 'src/features/password/locales/pl';
import polls from 'src/features/polls/locales/pl';
import siteApplications from 'src/features/site-applications/locales/pl';
import siteAssets from 'src/features/site-assets/locales/pl';
import siteAuditLogs from 'src/features/site-audit-logs/locales/pl';
import siteDetails from 'src/features/site-details/locales/pl';
import siteEnvironmentalIndicators from 'src/features/site-environmental-indicators/locales/pl';
import siteEvents from 'src/features/site-events/locales/pl';
import siteFaqs from 'src/features/site-faqs/locales/pl';
import siteManagement from 'src/features/site-management/locales/pl';
import siteMessages from 'src/features/site-messages/locales/pl';
import siteMobileAppManagement from 'src/features/site-mobile-app-management/locales/pl';
import sitePermissions from 'src/features/site-permissions/locales/pl';
import sitePlaces from 'src/features/site-places/locales/pl';
import sitePolls from 'src/features/site-polls/locales/pl';
import sitePosts from 'src/features/site-posts/locales/pl';
import siteTenants from 'src/features/site-tenants/locales/pl';
import site from 'src/features/site/locales/pl';
import tenantAuditLogs from 'src/features/tenant-audit-logs/locales/pl';
import tenantContactForm from 'src/features/tenant-contact-form/locales/pl';
import tenantDetails from 'src/features/tenant-details/locales/pl';
import tenantDomains from 'src/features/tenant-domains/locales/pl';
import tenantEmployeeJoinMethod from 'src/features/tenant-employee-join-method/locales/pl';
import tenantEmployeesPermissions from 'src/features/tenant-employees-permissions/locales/pl';
import tenantEmployees from 'src/features/tenant-employees/locales/pl';
import tenantEvents from 'src/features/tenant-events/locales/pl';
import tenantManageInvitationDialogue from 'src/features/tenant-manage-invitation-dialogue/locales/pl';
import tenantMessages from 'src/features/tenant-messages/locales/pl';
import tenantPolls from 'src/features/tenant-polls/locales/pl';
import tenantPosts from 'src/features/tenant-posts/locales/pl';
import applications from './applications.json';
import auth from './auth.json';
import common from './common.json';
import components from './components.json';
import invitationSettings from './invitation-settings.json';
import organizationDetails from './organization-details.json';
import publications from './publications.json';
import routes from './routes.json';
import validation from './validation.json';
import textEditorValidation from 'src/utils/rich-text-editor/locales/pl';

const resources = {
  common,
  auth,
  validation,
  tenantEmployees,
  routes,
  tenantPolls,
  sitePolls,
  applications,
  organizationDetails,
  invitationSettings,
  tenantDomains,
  tenantEmployeeJoinMethod,
  tenantContactForm,
  tenantEmployeesPermissions,
  tenantManageInvitationDialogue,
  tenantPosts,
  tenantEvents,
  siteTenants,
  siteManagement,
  sitePlaces,
  publications,
  events,
  siteEvents,
  sitePosts,
  polls,
  siteDetails,
  siteEnvironmentalIndicators,
  siteApplications,
  sitePermissions,
  createSite,
  siteAssets,
  siteMobileAppManagement,
  password,
  tenantDetails,
  site,
  siteFaqs,
  siteMessages,
  messages,
  tenantMessages,
  components,
  auditLogs,
  tenantAuditLogs,
  siteAuditLogs,
  authFeature,
  siteIssues,
  issues,
  issueManagers,
  issuesManagement,
  textEditorValidation,
} as const;

export default resources;
